import * as React from "react";
import { IEnumerable } from "../models/ModelHelpers";
import { useHubXSubscribe } from "../../HubX";
import { EVENT_DATEPICKER_CHANGE } from "../../Events";
import { DateWindow } from "../models/DateWindow";

export function useHubEventDateWindow(id: IEnumerable, useCustomEvent = false) {
  const [datewindow, setDateWindow] = React.useState<DateWindow | null>(null);

  useHubXSubscribe(useCustomEvent ? id.toString() : EVENT_DATEPICKER_CHANGE(id), setDateWindow);

  return datewindow;
}

export function useHubXValue<T>(event: string, initialValue?: T, useBuffer = false) {
  const [value, setValue] = React.useState<T>(initialValue as T);

  useHubXSubscribe(event, setValue, useBuffer);

  return value;
}
